import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';


const Drp_DocSettingType = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const [SelectList, setSelectList] = React.useState([]);
    const [Id, setId] = React.useState(-1);
    const [IsDrp, setIsDrp] = React.useState(-1);
    const [UsedIn, setUsedIn] = React.useState(-1);
    const _Onchange = (value) => {
        props.onChange(value == null ? -1 : value, value == null ? "" : List.find(x => x.Id == value).Title)
        setId(value)
    }
    const _OnChecking = (value, id) => {
        var temp = [...SelectList];

        var index = temp.findIndex(x => x.Id == id);
        console.dir(index);
        if (index == -1 && value == true) {
            console.dir(temp)
            temp.push({
                docSettingType: id,
                docSettingUsedIn: UsedIn
            })
            console.dir(temp)
        }
        else if (index == -1 && value == false) {
            temp.splice(index, 1);
        }
        setSelectList(temp);
        props.onChange(temp)
    }
    useImperativeHandle(ref, () => ({

        Bind(id, usedIn, isDrp = 1, selectList) {
            console.dir(usedIn)
            console.dir(IsDrp)
            setIsDrp(isDrp);
            setSelectList(selectList);
            setUsedIn(usedIn)
            var temp = [];
            if (usedIn == -1 && isDrp == 1)
                temp.push({
                    Id: -1,
                    Title: 'هیچکدام',
                })
            else if (usedIn == 1) // Sale
                temp.push(
                    {
                        Id: -1,
                        Title: 'هیچکدام',
                    },
                    {
                        Id: 0,
                        Title: "معین فاکتور فروش/ اسناد دریافتنی",
                    },
                    {
                        Id: 1,
                        Title: "معین برگشت از فروش",
                    },
                    {
                        Id: 2,
                        Title: "معین درآمد کرایه",
                    },
                    {
                        Id: 3,
                        Title: "معین تخفیفات نقدی",
                    },
                    {
                        Id: 4,
                        Title: "معین پیش دریافت ها",
                    },
                    {
                        Id: 5,
                        Title: "معین دریافت ها",
                    },
                    {
                        Id: 6,
                        Title: "معین تهاتر",
                    }

                )

            else if (usedIn == 2) // PaymentReceived
                temp.push({
                    Id: -1,
                    Title: 'هیچکدام',
                },
                    {
                        Id: 0,
                        Title: "معین انتقال بین بانک",
                    },
                    {
                        Id: 1,
                        Title: "معین استرداد وجه",
                    },
                    {
                        Id: 2,
                        Title: "معین برگشت چک / واخواست چک",
                    },
                    {
                        Id: 3,
                        Title: "معین خرج کردن چک",
                    },
                    {
                        Id: 4,
                        Title: "معین نقد کردن چک",
                    },
                    {
                        Id: 5,
                        Title: "معین انتقال بین صندوق",
                    },
                    {
                        Id: 6,
                        Title: "معین انتقال از صندوق به بانک",
                    },
                    {
                        Id: 7,
                        Title: "معین پرداخت به تامین کننده",
                    },
                    {
                        Id: 8,
                        Title: "معین پرداخت تنخواه",
                    }
                )

            else if (usedIn == 3) // ReceiptReceived
                temp.push({
                    Id: -1,
                    Title: 'هیچکدام',
                }, {
                    Id: 0,
                    Title: "معین انتقال بین بانکی ",
                }, {
                    Id: 1,
                    Title: "معین پاس شدن چک",
                }, {
                    Id: 2,
                    Title: "معین برگشت چک / واخواست چک ",
                }, {
                    Id: 3,
                    Title: "معین برگشت چک ناشی از خرج کردن چک",
                }, {
                    Id: 4,
                    Title: "معین نقد کردن چک",
                }, {
                    Id: 5,
                    Title: "معین چک های در جریان وصول / واگزاری چک به بانک",
                }, {
                    Id: 6,
                    Title: "معین بین صندوق",
                }, {
                    Id: 7,
                    Title: "معین انتقال از صندوق به بانک",
                }
                )

            else if (usedIn == 4) // General
                temp.push({
                    Id: -1,
                    Title: 'هیچکدام',
                }, {
                    Id: 0,
                    Title: "معین سند افتتاحیه",
                }, {
                    Id: 1,
                    Title: "معین سند اختتامیه",
                }
                )

            else if (usedIn == 5) // Store
                temp.push({
                    Id: -1,
                    Title: 'هیچکدام',
                }, {
                    Id: 0,
                    Title: "معین رسید اضافه انبارگردانی",
                }, {
                    Id: 1,
                    Title: "معین حواله کسری انبارگردانی",
                }, {
                    Id: 2,
                    Title: "معین رسید انتقال بین انبارها",
                }, {
                    Id: 3,
                    Title: "معین حواله انتقال بین انبارها",
                }, {
                    Id: 4,
                    Title: "معین رسید کالای امانی",
                }, {
                    Id: 5,
                    Title: "معین رسید برگشت کالای امانی",
                }, {
                    Id: 6,
                    Title: "معین رسید خرید",
                }, {
                    Id: 7,
                    Title: "معین حواله برگشت از خرید",
                }, {
                    Id: 8,
                    Title: "معین حواله کالای امانی",
                }, {
                    Id: 9,
                    Title: "معین حواله برگشت کالای امانی",
                }, {
                    Id: 10,
                    Title: "معین حواله فروش",
                }, {
                    Id: 11,
                    Title: "معین حواله برگشت از فروش",
                }, {
                    Id: 12,
                    Title: "معین رسید اول دوره",
                }, {
                    Id: 13,
                    Title: "معین حواله اول دوره",
                }
                )

            else if (usedIn == 6) // Tax
                temp.push({
                    Id: -1,
                    Title: 'هیچکدام',
                }, {
                    Id: 0,
                    Title: "معین پیش پرداخت مالیات",
                }, {
                    Id: 1,
                    Title: "معین مالیات پرداختی",
                }, {
                    Id: 2,
                    Title: "معین عوارض پرداختی",
                }, {
                    Id: 3,
                    Title: "معین پیش پرداخت عوارض",
                }
                )

            else if (usedIn == 7) // Paybox
                temp.push({
                    Id: -1,
                    Title: 'هیچکدام',
                }, {
                    Id: 0,
                    Title: "معین موجودی بانک",

                }, {
                    Id: 1,
                    Title: "معین موجودی صندوق",
                }, {
                    Id: 2,
                    Title: "معین موجودی کارت خوان",
                }, {
                    Id: 3,
                    Title: "معین اسناد نزد صندوق",
                }, {
                    Id: 4,
                    Title: "معین اسناد واخواست شده نزد صندوق",
                }, {
                    Id: 5,
                    Title: "معین اسناد پرداختنی",
                }, {
                    Id: 6,
                    Title: "معین اسناد دریافتنی",
                }, {
                    Id: 7,
                    Title: "معین اسناد واخواست شده",
                }, {
                    Id: 8,
                    Title: "معین کارمزد بانک",
                }, {
                    Id: 9,
                    Title: "معین سند افتتاحیه",
                }, {
                    Id: 10,
                    Title: "معین حساب واسط",
                }
                )

            else if (usedIn == 8) // Police
                temp.push({
                    Id: -1,
                    Title: 'هیچکدام',
                }
                )


            if (isDrp == 1) {

                setId(id)
                props.onChange(id == null ? -1 : id, id == null ? "" : temp.find(x => x.Id == id).Title)
            }
            else {
                setSelectList(selectList);
                props.onChange(selectList)

            }
            setList(temp);


        },

    }))



    return (
        <>
            {IsDrp == 1 ?
                <rsuite.SelectPicker


                    data={List}
                    valueKey="Id"
                    labelKey="Title"
                    className='w-100p'
                    placeholder="انتخاب کنید..."
                    value={Id}
                    onChange={(value) => _Onchange(value)}

                />
                :
                <>
                    {List.map(item => (
                            <rsuite.Col className={item.Id != -1 ? '' : 'hide'} xxl={12} xl={12} lg={12} md={24} sm={24} xs={24} >
                                <rsuite.Checkbox onChange={(e, checked) => _OnChecking(checked, item.Id)}
                                    checked={SelectList.findIndex(x => x.docSettingType == item.Id && x.docSettingUsedIn == UsedIn) == -1 ? false : true}
                                    value={SelectList.findIndex(x => x.docSettingType == item.Id && x.docSettingUsedIn == UsedIn) == -1 ? false : true} /> &nbsp;  {item.Title}
                            </rsuite.Col>

                        ))}
                </>

            }
        </>


    )
});

export default Drp_DocSettingType;